import { ImageButton } from "./image-button.js"
import { classes } from "utils"
import ThreeDotsIcon from "icons/three-dots.svg"
import { colors } from "design"
import {
  offset,
  useRole,
  useClick,
  useDismiss,
  useFloating,
  useInteractions,
  FloatingOverlay,
  FloatingFocusManager,
} from "@floating-ui/react"
import { useState } from "react"

export const actionVariablesLight = {
  "--resbird-action-background-color": colors.cream,
  "--resbird-hover-background-color": colors.grey50,
  "--resbird-action-font-color": colors.grey500,
  "--resbird-action-hover-font-color": colors.primaryBlueGrey,
}

export const Actions = ({ className, actions, listStyle, ...props }) => {
  const [isOpen, setIsOpen] = useState(false)
  const { refs, floatingStyles, context } = useFloating({
    open: isOpen,
    placement: "left-start",
    onOpenChange: setIsOpen,
    middleware: [offset({ mainAxis: -15, crossAxis: -10 })],
  })

  const { getReferenceProps, getFloatingProps } = useInteractions([
    useClick(context),
    useRole(context),
    useDismiss(context, { outsidePress: true }),
  ])

  // if (!children) return
  return (
    <>
      <ImageButton
        className={classes(className, "toggle-list-button")}
        css={{ height: "max-content" }}
        icon={ThreeDotsIcon}
        ref={refs.setReference}
        {...getReferenceProps()}
      />
      {isOpen && (
        <FloatingOverlay className="actions-floating-overlay" lockScroll>
          <FloatingFocusManager context={context} initialFocus={1}>
            <ul
              className="actions"
              css={[
                floatingStyles,
                {
                  background: "var(--resbird-action-background-color)",
                  boxShadow: "0px 3px 8px #00000029",
                  borderRadius: 4,
                  padding: 0,
                  paddingTop: 10,
                  paddingBottom: 10,
                },
              ]}
              ref={refs.setFloating}
              {...getFloatingProps()}
            >
              {_.map(actions, ({ type, callback }, index) => (
                <li
                  className={classes(_.kebabCase(type), "action-item")}
                  onClick={() => callback(props)}
                  css={[
                    {
                      padding: "11px 34px",
                      cursor: "pointer",
                      listStyle: "none",
                      color: "var(--resbird-action-font-color)",
                      "&:hover": {
                        opactiy: 0.8,
                        color: "var(--resbird-action-hover-font-color)",
                      },
                    },
                    listStyle,
                  ]}
                  key={index}
                >
                  {type}
                </li>
              ))}
            </ul>
          </FloatingFocusManager>
        </FloatingOverlay>
      )}
    </>
  )
}
